import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'; // For programmatic navigation
import apiCall from 'components/Api/api';
import dpimg from "assets/img/dpmain.png";
import { useScreenSize } from 'provider/ScreenSizeProvider';
import HeaderPayment from 'components/common/HeaderPayment';
import FooterPayment from 'components/common/FooterPayment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndianRupeeSign } from '@fortawesome/free-solid-svg-icons';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const PaymentComponent = () => {
    const { txnid } = useParams();
    const location = useLocation();
    const { screenHeight } = useScreenSize();
    const queryParams = new URLSearchParams(location.search);
    const utmSource = queryParams.get('utm_source');
    const [infoLoading, setIndoLoading] = useState(true)
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [infoError, setInfoError] = useState('');
    const [error, setError] = useState(null);
    const [transId, setTransId] = useState(txnid);
    const [paymentOption, setPaymentOption] = useState('payu');
    const [gstNumber, setGstNumber] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [quotationDetail, setQuotationDetail] = useState(null);
    const navigate = useNavigate(); // Hook for navigation
    const [organizerImageError, setOrganizerImageError] = useState(false);

    const backendApiUrl = `${BASE_URL}/transaction/initiate/${transId}/${paymentOption}`;
    // const payuPaymentUrl = 'https://secure.payu.in/_payment'; // Use test URL for testing, change to production for live


    useEffect(() => {
        const fetchVerification = async () => {
            try {
                setIndoLoading(true);
                setInfoError(null);


                const { status: httpStatus, data } = await apiCall({
                    url: `quotation-info/${transId}`,
                    method: 'GET',
                });

                if (httpStatus !== 200 || !data) {
                    setInfoError(data?.message);
                    return;
                }
                const { status, message, quotation } = data;
                if (status === 0) {
                    // server is telling you something went wrong
                    setInfoError(message);
                } else if (quotation) {
                    // success path – show the quotation
                    setQuotationDetail(quotation);
                } else {
                    // unexpected payload shape
                    setInfoError('Unexpected server response.');
                }
            } catch (err) {
                console.error("Verification error:", err);
                setInfoError('Something went wrong while verifying the payment.');
            } finally {
                setIndoLoading(false);
            }
        };

        if (transId) {
            fetchVerification();
        }
    }, [transId]);


    function escapeHtml(str) {
        if (typeof str !== "string") return str;
        return str.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }


    const handleInitiatePayment = async () => {
        if (loading) return;
        setLoading(true);
        setError(null);
        let redirecting = false;
        try {
            const response = await apiCall({
                url: `transaction/initiate/${transId}/${paymentOption}?utm_source=${utmSource}`,
                method: "GET",
            });

            if (response?.status === 200 && response?.data?.payu) {
                const { hash, ...payuParams } = response?.data?.payu;
                const payuPaymentUrl = response?.data?.payu_transaction_url;

                if (hash) {
                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = payuPaymentUrl;

                    for (const key in payuParams) {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = escapeHtml(key);
                        input.value = escapeHtml(payuParams[key]);
                        form.appendChild(input);
                    }

                    const hashInput = document.createElement('input');
                    hashInput.type = 'hidden';
                    hashInput.name = 'hash';
                    hashInput.value = hash;
                    form.appendChild(hashInput);

                    // return
                    document.body.appendChild(form);

                    redirecting = true;
                    form.submit();
                } else {
                    setError('Failed to generate PayU hash.');
                }
            } else {
                if (response?.data?.status === 0) {
                    setMessage(response?.data?.message)
                } else {
                    setError('Invalid response from server.');
                }
            }

        } catch (error) {
            console.error('Payment initiation error:', error);
            setError('An error occurred during payment initiation.');
        } finally {
            if (!redirecting) setLoading(false);
        }
    };

    const formatNumber = (num) => {
        if (num === undefined || num === null || isNaN(num)) return "N/A";
        return num.toString().padStart(2, '0');
    };

    const formatNumberWithDecimal = (num) => {
        if (num === undefined || num === null || isNaN(num)) return "N/A";
        return Number(num).toFixed(2);
    };

    if (infoLoading) {
        return (
            <>
                <HeaderPayment />
                <div className="container  py-4 payment_section-inner d-flex justify-content-center align-items-center" >
                    <div className="row w-100 justify-content-center">
                        <div className="col-lg-10 col-md-12">
                            <div className="card shadow p-4" style={{ height: screenHeight - 450 }}>
                                <div className="text-center">
                                    <div className="spinner-border loading-spinner" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <div className="mt-3">Getting payment info...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterPayment />
            </>

        );
    }

    if (!infoLoading && infoError) {
        return (
            <>
                <HeaderPayment />
                <div className="container  py-4 payment_section-inner d-flex justify-content-center align-items-center" >
                    <div className="row w-100 justify-content-center">
                        <div className="col-lg-10 col-md-12">
                            <div className="card shadow p-4" style={{ height: screenHeight - 450 }}>
                                <div className="text-center">
                                    <div className="mt-3 text-danger">{infoError}</div>
                                    <div className=" d-flex justify-content-center joinshareView mt-md-3 mt-lg-3">
                                        <Link to="/" className="btn_shareView pakage">
                                            {'Continue'}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterPayment />
            </>
        );
    }

    const subtotal = quotationDetail?.amount ? quotationDetail.amount * 0.95 : 0;
    const gst = quotationDetail?.amount ? quotationDetail.amount * 0.05 : 0;
    const total = quotationDetail?.amount ?? 0;

    return (

        <>
            <HeaderPayment />
            <div className="container py-4 payment_section-inner ">
                <div className="row w-100 justify-content-center">
                    <div className="col-lg-10 col-md-12">
                        <div className="card card-order py-4 px-3 px-md-4 px-lg-5" >
                            <div className="row g-4">
                                {/* === Left Column === */}
                                <div className="col-lg-8">
                                    <div className="mb-3 fs-4 fw-medium ">Order Summary</div>
                                    <h6 className="pt-3 park-heading">
                                        {quotationDetail?.title?.trim() ? quotationDetail.title : 'gfh'}
                                    </h6>
                                    {quotationDetail &&
                                        <>
                                            <p className="mb-3 park-op-title">Organized by {quotationDetail?.partner ?? ''}</p>

                                            <div className="row mb-2">
                                                <div className="col-lg-8 col-md-12 d-flex justify-content-between">
                                                    <div className="payment-sum-heading me-auto">Park</div>
                                                    <div className="payment-sum-title ms-auto">{quotationDetail?.park_name ?? ''}</div>
                                                </div>
                                            </div>

                                            <div className="row mb-2">
                                                <div className="col-lg-8 col-md-12 d-flex justify-content-between">
                                                    <div className="payment-sum-heading me-auto">Travelers</div>
                                                    <div className="payment-sum-title ms-auto">{formatNumber(quotationDetail?.travelers)}</div>
                                                </div>
                                            </div>

                                            <div className="row mb-2">
                                                <div className="col-lg-8 col-md-12 d-flex justify-content-between">
                                                    <div className="payment-sum-heading me-auto">Safaris</div>
                                                    <div className="payment-sum-title ms-auto">{formatNumber(quotationDetail?.safaris ?? '')}</div>
                                                </div>
                                            </div>

                                            <div className="row mb-2">
                                                <div className="col-lg-8 col-md-12 d-flex justify-content-between">
                                                    <div className="payment-sum-heading me-auto">Stay Category</div>
                                                    <div className="payment-sum-title ms-auto">{quotationDetail?.stay_category_label ?? ''}</div>
                                                </div>
                                            </div>

                                            <div className="row mb-2">
                                                <div className="col-lg-8 col-md-12 d-flex justify-content-between">
                                                    <div className="payment-sum-heading me-auto">Start Date</div>
                                                    <div className="payment-sum-title ms-auto">{quotationDetail?.start_date ?? ''}</div>
                                                </div>
                                            </div>

                                            <div className="row mb-4">
                                                <div className="col-lg-8 col-md-12 d-flex justify-content-between">
                                                    <div className="payment-sum-heading me-auto">End Date</div>
                                                    <div className="payment-sum-title ms-auto">{quotationDetail?.end_date ?? ''}</div>
                                                </div>
                                            </div>

                                            {quotationDetail?.additional_notes && <div className="row">
                                                <div className="col-lg-11 col-12  align-items-start">
                                                    <h6 className="fw-semibold m-0">Note:</h6>
                                                    <p className="mb-0 payment-notes">
                                                        {quotationDetail?.additional_notes}
                                                    </p>
                                                </div>
                                            </div>
                                            }
                                            <div className='w-100 d-lg-none payment-method-divider'></div>
                                            <div className="d-flex gap-3 mb-4 mt-lg-4 pt-2 align-items-start" style={{ fontSize: '13px' }}>
                                                {/* Profile Image */}
                                                <div className="profilewrapper">
                                                    <div className="profile footer_card2 ">
                                                        <div className="img-box2 payment-profile users">
                                                            <img
                                                                src={
                                                                    organizerImageError || !quotationDetail?.profile_display_image
                                                                        ? dpimg
                                                                        : quotationDetail?.profile_display_image
                                                                }
                                                                alt="Organizer"
                                                                className="rounded-circle bg-info"
                                                                onError={() => setOrganizerImageError(true)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* Profile Info */}
                                                <div>
                                                    <div className="row mb-1">
                                                        <div className="col d-flex gap-5 justify-content-between">
                                                            <div className="">Name</div>
                                                            <div className="me-auto">{quotationDetail?.name ?? ''}</div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-1">
                                                        <div className="col d-flex gap-5 justify-content-between">
                                                            <div className="">Email</div>
                                                            <div className="me-auto">{quotationDetail?.email ?? ''}</div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col d-flex gap-5 justify-content-between">
                                                            <div className="">Phone</div>
                                                            <div className="me-auto">{quotationDetail?.phone ?? ''}</div>
                                                        </div>
                                                    </div>

                                                    <div className="row pt-lg-4 pt-md-4">
                                                        <div className="col d-flex gap-5 justify-content-between">
                                                            <div className="payment-heading">Quantity x {quotationDetail?.quantity ?? ''}</div>
                                                            <div className="payment-amount me-auto"> <FontAwesomeIcon
                                                                                                        icon={faIndianRupeeSign}
                                                                                                        color="#fd5634"
                                                                                                        size="sm"
                                                                                                    /> {formatNumberWithDecimal(quotationDetail?.amount)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='w-100 d-lg-none payment-method-divider'></div>
                                        </>
                                    }
                                </div>

                                {/* === Right Column === */}
                                {quotationDetail?.is_payment_received ?

                                    <div className="col-lg-4  pt-0 py-0">
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                {<div className='text-danger mt-2'>{quotationDetail?.if_payment_received_then_message}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="col-lg-4 pt-0 py-0">
                                        {/* Payment Method */}
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <div className="payment-method mb-3">Payment Method</div>
                                                <div className="mb-2">
                                                    {/* <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentMethod"
                                            id="payuRadio"
                                            value="payu"
                                            checked={paymentOption === 'payu'}
                                            onChange={(e) => setPaymentOption(e.target.value)}
                                        /> */}
                                                    <label className="form-check-label d-flex align-items-center gap-2" htmlFor="payuRadio">
                                                        <img src={'/img/payu2.svg'} alt="PayU" width="70" />
                                                        {/* <span className='payu-logo-title'>PayU</span> */}
                                                    </label>
                                                </div>

                                                {/* <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentMethod"
                                            id="iciciRadio"
                                            value="icici"
                                            checked={paymentOption === 'icici'}
                                            onChange={(e) => setPaymentOption(e.target.value)}
                                        />
                                        <label className="form-check-label d-flex align-items-center gap-2" htmlFor="iciciRadio">
                                            <img src="https://i.imgur.com/bX7M5Nl.png" alt="ICICI" width="70" />
                                            <span>ICICI</span>
                                        </label>
                                    </div> */}
                                            </div>
                                        </div>

                                        {/* Price Breakdown */}
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <ul className="list-unstyled mb-4">
                                                    <li className="d-flex justify-content-between mb-2">
                                                        <span className='payment-summry-heading'>Subtotal</span>
                                                        <span className='payment-summry-amount'><FontAwesomeIcon
                                                                                                        icon={faIndianRupeeSign}
                                                                                                        color="#fd5634"
                                                                                                        size="sm"
                                                                                                    /> {formatNumberWithDecimal(subtotal)}</span>
                                                    </li>
                                                    <li className="d-flex justify-content-between mb-2">
                                                        <span className='payment-summry-heading'>GST (5%)</span>
                                                        <span className='payment-summry-amount'><FontAwesomeIcon
                                                                                                        icon={faIndianRupeeSign}
                                                                                                        color="#fd5634"
                                                                                                        size="sm"
                                                                                                    /> {formatNumberWithDecimal(gst)}</span>
                                                    </li>

                                                    <li className="d-flex justify-content-between border-top pt-2 fw-bold">
                                                        <span className='payment-summry-total'>Total</span>
                                                        <span className='payment-summry-amount-total'><FontAwesomeIcon
                                                                                                        icon={faIndianRupeeSign}
                                                                                                        color="#fd5634"
                                                                                                        size="sm"
                                                                                                    /> {formatNumberWithDecimal(total)}</span>
                                                    </li>
                                                </ul>


                                                {/* <div className="mb-3">
                                                    <label htmlFor="gstNumber" className="form-label">GST Number (optional)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="gstNumber"
                                                        placeholder="Enter GST Number"
                                                        value={gstNumber}
                                                        onChange={(e) => setGstNumber(e.target.value)}
                                                    />
                                                </div>


                                                <div className="mb-3">
                                                    <label htmlFor="companyName" className="form-label">Company Name (optional)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="companyName"
                                                        placeholder="Enter Company Name"
                                                        value={companyName}
                                                        onChange={(e) => setCompanyName(e.target.value)}
                                                    />
                                                </div> */}

                                                <div className="btn-payment-pay  w-100 fw-semibold" onClick={handleInitiatePayment} disabled={loading}>
                                                    {loading ? 'Processing...' : 'Pay'}
                                                </div>
                                                {<div className='text-danger mt-2'>{message}</div>}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterPayment footerHeight={170} />
        </>
    );
};

export default PaymentComponent;